import { createFileRoute } from "@tanstack/react-router"
import { RoyaltiesPage } from "./-components/royalties-page"

export const Route = createFileRoute("/app/art/royalties/")({
  beforeLoad: (ctx) => ({ getTitle: () => ctx.context.t("Royalties") }),
  component: RoyaltiesPage,
})
